<template>
  <panel>
    <wizard :title="title" :steps="steps" @changeStep="changeStep">
      <router-view @nextStep="nextStep" @previousStep="previousStep" />
    </wizard>
  </panel>
</template>

<script>
import Panel from '@/components/panel/Panel.vue';
import Wizard from '@/components/wizard/Wizard.vue';
import { wizardMixin } from '@/mixins/wizard';

// @vuese
// Komponent do zarządzania procedurą
export default {
  components: { Panel },
  mixins: [wizardMixin('procedure')]
};
</script>
